import { IAppState } from '../../../AppModulesWrapper';

import { EOfferStatus } from '../../types/reducers/offer';

export function selectIsDraftOffer(state: IAppState): boolean {
  return state.servicePickerWidget.offer.status === EOfferStatus.draft;
}
